import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, CardBody, CardHeader, Col, Row, Spinner } from "reactstrap";
import BarChart from "components/shared/Charts/BarChart";
import { fetchPeakHours } from "store/actions/statsActions";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const PeakHours = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id:
      user?.type === "restaurant"
        ? user?.restaurantID
        : user?.type === "admin" && merchant?.id
        ? merchant?.id
        : ""
  };

  const {
    data: peakHoursData,
    isFetching,
    isError,
    error
  } = useQuery({
    queryKey: ["peakHours", payload],
    queryFn: () => dispatch(fetchPeakHours(payload)),
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true
  });

  const formatHour = (hour) => {
    const hr = parseInt(hour, 10);
    const suffix = hr >= 12 ? "PM" : "AM";
    const formatted = hr % 12 === 0 ? 12 : hr % 12;
    return `${formatted}${suffix}`;
  };

  const formatTimeRange = (range) => {
    const [start, end] = range.split("-").map((h) => h.padStart(2, "0"));
    return `${formatHour(start)} - ${formatHour(end)}`;
  };

  const latestPeakHours = peakHoursData || {};

  const options = {
    chart: { type: "bar", toolbar: { show: false } },
    xaxis: {
      categories: Object.keys(latestPeakHours).map(formatTimeRange),
      labels: { style: { fontFamily: "Poppins, sans-serif" } }
    },
    fill: { colors: ["#F765A3"] },
    dataLabels: { enabled: false },
    tooltip: { enabled: true }
  };

  const series = [
    {
      name: "Visits",
      data: Object.values(latestPeakHours)
    }
  ];

  if (isError) {
    toast.error(error?.message || "Failed to load peak hours.");
  }

  return (
    <Row>
      <Col xl={12}>
        <Card className="header-cards card overflow-hidden">
          <CardHeader>
            <h3 className="">Peak Hours</h3>
          </CardHeader>
          {isFetching ? (
            <Spinner className="mx-auto my-5" size="sm" color="primary" />
          ) : (
            <CardBody>
              <BarChart options={options} series={series} />
            </CardBody>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default PeakHours;
